import React from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";
import { selectLoan, selectLoanLoading } from "@/store/selectors";
import { PeriodTypeId } from "../../../helpers/helpers";
import { RUSSIAN_LOCALE } from "../../../helpers/const";
import { LoanSelector } from "./LoanSelector";
import { TermSelector } from "./TermSelector";
import { useCalculator, CalculatorType } from "../hooks";
import { LoanAmount } from "../LoanAmount";
import "./index.css";
import { Spinner, SpinnerColor, SpinnerSize } from "../../widgets/Spinner";

export const Calculator = ({ calculatorType }) => {
  const amounts = useSelector(selectLoan);
  const loadingOnChange = useSelector(selectLoanLoading);

  const {
    days,
    weeks,
    loanItems,
    periodItems,
    getSumScaleItem,
    getPeriodScaleItem,
    calculatorSettings,
    recalculateOnChangeLoan,
    recalculateOnChangePeriod,
  } = useCalculator(calculatorType);

  const loading = Object.entries(calculatorSettings).length === 0;
  const selectedLoan = loanItems.find((i) => i.number === amounts.loanAmount);
  const selectedTerm = periodItems.find(
    (i) => i.number === amounts.term && amounts.periodTypeId === i.periodTypeId
  );
  const isProduct = calculatorType === CalculatorType.PRODUCT;

  const hasDaysAndWeeks = days?.length > 0 && weeks?.length > 0;

  return (
    <div
      className={`${
        calculatorType === CalculatorType.REGAUTH ? "col-md-4" : ""
      } sidebar-col md-hide`}>
      <div className="h2">
        <ul
          className={classNames("calc-btn", { "calc-btn--small": isProduct })}>
          <li className={classNames("pluse", { "pluse--small": isProduct })}>
            +
          </li>
          <li className={classNames("minuse", { "minuse--small": isProduct })}>
            -
          </li>
          <li
            className={classNames("multiply", {
              "multiply--small": isProduct,
            })}>
            *
          </li>
          <li
            className={classNames("exactly", { "exactly--small": isProduct })}>
            =
          </li>
        </ul>
        <h2>Онлайн калькулятор заявки</h2>
      </div>
      <ul
        className={classNames("sidebar-calculator", "form-list", { loading })}>
        <LoanSelector
          selected={selectedLoan}
          items={loanItems}
          onSelect={(item) => recalculateOnChangeLoan(item.number)}
        />
        <li className="item">
          <ul className="item_list">
            <li>{getSumScaleItem(0)}</li>
            <li>{getSumScaleItem(1)}</li>
            <li>{getSumScaleItem(2)}</li>
          </ul>
        </li>
        <LoanAmount />
        <TermSelector
          selected={selectedTerm}
          items={periodItems}
          onSelect={(item) => recalculateOnChangePeriod(item)}
        />
        <li className="item">
          <ul className="item_list">
            {hasDaysAndWeeks && <li>{getPeriodScaleItem(0)}</li>}
            {periodItems?.length >= 2 && (
              <li className={hasDaysAndWeeks ? "second-item" : ""}>
                {getPeriodScaleItem(1)}
              </li>
            )}
            <li>{getPeriodScaleItem(2)}</li>
          </ul>
        </li>

        <li className="item item_sum">
          <ul className="item_list">
            <li>
              <span>
                {amounts.periodTypeId === PeriodTypeId.days
                  ? "Сумма к возврату:"
                  : "Платеж раз в 2 недели:"}
              </span>
              <div className="green">
                {loadingOnChange ? (
                  <Spinner
                    className="mr-3"
                    size={SpinnerSize.small}
                    color={SpinnerColor.primary}
                  />
                ) : (
                  `${(
                    amounts.paymentAmount || amounts.refundAmount
                  )?.toLocaleString(RUSSIAN_LOCALE)} ₽`
                )}
              </div>
            </li>
            <li>
              <span>Сумма переплаты:</span>
              <div className="green">
                {loadingOnChange ? (
                  <Spinner
                    className="mr-3"
                    size={SpinnerSize.small}
                    color={SpinnerColor.primary}
                  />
                ) : (
                  `${amounts.overpaymentAmount?.toLocaleString(
                    RUSSIAN_LOCALE
                  )} ₽`
                )}
              </div>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  );
};
